import LogsIndex from '@/pages/audit/logs/Index'
import LogsDetail from '@/pages/audit/logs/Detail'

const AuditRoutes = [    
    {path: '/audit/logs', name: 'logs.index', component: LogsIndex, meta: {permission: 'logs.index'}},
    {path: '/audit/logs/detail/:id', name: 'logs.detail', component: LogsDetail, meta: {permission: 'logs.detail'}}
];

export default AuditRoutes;